import React from 'react';
import {
    Alert,
    Code,
    Divider,
    Heading,
    ListItem,
    OrderedList,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    UnorderedList,
} from '@chakra-ui/react';
import Image from 'next/image';
import {NextChakraLink} from '../components/next-chakra-link';


// Possible values: https://mdxjs.com/advanced/typescript
export const components = {
    _ignore: Heading,
    em: ({children}) => {
        return <Text as="em">{children}</Text>;
    },
    blockquote: ({children}) => {
        return <Alert status="success" variant="left-accent">
            {children}
        </Alert>
    },
    code: ({className, children}) => {
        return (
            <Code p={2} className={className || null}>
                {children}
            </Code>
        );
    },
    del: ({children}) => {
        return <Text as="del">{children}</Text>;
    },
    thematicBreak: Divider,
    a: ({href, children}) => {
        {/*@ts-ignore*/}
        return <NextChakraLink color={'#b0b0b0'} href={href}>{children}</NextChakraLink>
    },
    img: ({alt, src}) => {
        return <Image height={200} width={200} alt={alt} src={src}/>
    },
    p: ({children}) => {
        return <Text pb="2">{children}</Text>;
    },
    ul: ({children}) => {
        return <UnorderedList>{children}</UnorderedList>
    },
    ol: ({children}) => {
        return <OrderedList ml={'2rem'}>{children}</OrderedList>
    },
    li: ({children}) => {
        return <ListItem>{children}</ListItem>
    },
    h1: ({children}) => heading(1, children),
    h2: ({children}) => heading(2, children),
    h3: ({children}) => heading(3, children),
    h4: ({children}) => heading(4, children),
    h5: ({children}) => heading(5, children),
    h6: ({children}) => heading(6, children),
    inlineCode: ({children}) => {
        return <Code>{children}</Code>;
    },
    table: ({children}) => {
        return <Table variant={'simple'}>{children}</Table>
    },
    tr: Tr,
    td: Td,
    thead: Thead,
    th: Th,
    tbody: Tbody,
}


function heading(level, children) {
    const sizes = ['2xl', 'xl', 'lg', 'md', 'sm', 'xs'];
    return (
        <Heading
            css={{hyphens: 'auto'}}
            my={4}
            // @ts-ignore
            as={`h${level}`}
            size={sizes[`${level - 1}`]}
        >
            {children}
        </Heading>
    );
}
